import React from 'react';
import styles from 'components/setting-filter-form/styles/SettingFilterForm.module.scss';

const FilterSection: React.FC = ({ children }) => {
  return <div className={styles.fieldSection}>{children}</div>;
};

export default FilterSection;
